import { all, call, fork, put, select, take, takeEvery, takeLatest } from 'redux-saga/effects';
import { gcApi } from 'config/axios';

import { isChinaUser } from 'utils/ChinaUtil';
import Util from 'backbone/views/utils/LeafletMap/utils/Util';

/** redux selector */
import { selectGroup, selectViewerSocialProfile } from 'reducers/group/groupPage';
import { selectGroupPageGroupCourses, selectGroupPageUserCourses } from 'reducers/group/groupPageCourse';

/** redux actions */
import {
    initCourseTabDone,
    addGroupCourseDone,
    fetchGroupCourseDetail,
    fetchGroupCourseDetailDone,
    deleteGroupCourseDone
} from '../actions/groupPageActions';

import {
    GROUP_PAGE_ADD_GROUP_COURSE,
    GROUP_PAGE_DELETE_GROUP_COURSE,
    GROUP_PAGE_FETCH_COURSE_DETAIL,
    GROUP_PAGE_INIT_COURSE_TAB
} from '../actions/ActionTypes';

import '../actions/groupPageActionsTypeDefs';

export function* fetchGroupCourseDetailSaga({ groupCourseId }) {
    const chinaUser = isChinaUser();

    const options = {};

    if (chinaUser) {
        options.params = {
            targetCoordinateSystem: Util.CoordinateSystem.BD09
        };
    }

    try {
        const response = yield call(gcApi.get, `/course-service/course/${groupCourseId}`, options);
        yield put(fetchGroupCourseDetailDone({ groupCourseId, groupCourseDetail: response.data }));
    } catch (error) {
        yield put(fetchGroupCourseDetailDone({ error: true, groupCourseId, groupCourseDetail: null }));
    }
}

export function* initCourseTabSaga() {
    const group = yield select(selectGroup);
    const viewerSocialProfile = yield select(selectViewerSocialProfile);

    try {
        const chinaUser = isChinaUser();
        let userCourseUrl = `/web-gateway/course/owner`;
        if (chinaUser) {
            userCourseUrl = `/course-service/course/to/${Util.CoordinateSystem.BD09}/CN/owner/${
                viewerSocialProfile.displayName
            }`;
        }
        const [userCoursesRes, groupCourseRes] = yield all([
            call(gcApi.get, userCourseUrl),
            call(gcApi.get, `/course-service/course/group/${group.id}`)
        ]);

        const userCourses = chinaUser ? userCoursesRes.data : userCoursesRes.data['coursesForUser'];
        const groupCourses = groupCourseRes.data || [];
        yield put(initCourseTabDone({ error: false, userCourses, groupCourses }));

        /** fetch detail for map */
        const putList = [];
        groupCourses.forEach((item) => {
            putList.push(put(fetchGroupCourseDetail({ groupCourseId: item.courseId })));
        });
        yield all(putList);
    } catch (error) {
        yield put(initCourseTabDone({ error: true, userCourses: [], groupCourses: [] }));
    }
}

export function* addGroupCourseSaga({ userCourseId }) {
    const group = yield select(selectGroup);
    const userCourses = yield select(selectGroupPageUserCourses);
    const course = userCourses.find((item) => item.courseId === userCourseId);
    if (!course) {
        return;
    }
    try {
        const response = yield call(gcApi.get, `/course-service/course/copycourse/${userCourseId}/group/${group.id}`);
        yield put(addGroupCourseDone(response.data));
        if (response.data && response.data.courseId) {
            yield put(fetchGroupCourseDetail({ groupCourseId: response.data.courseId }));
        }
    } catch (error) {}
}

export function* deleteGroupCourseSaga({ groupCourseId }) {
    const groupCourses = yield select(selectGroupPageGroupCourses);
    const course = groupCourses.find((item) => item.courseId === groupCourseId);
    if (!course) {
        yield put(deleteGroupCourseDone({ groupCourseId }));
        return;
    }

    try {
        yield call(gcApi.delete, `/course-service/course/${groupCourseId}`);
        yield put(deleteGroupCourseDone({ groupCourseId }));
    } catch (error) {
        yield put(deleteGroupCourseDone({ error: true, groupCourseId }));
    }
}

// watcher
export const groupPageCourseSagas = [
    takeLatest(GROUP_PAGE_INIT_COURSE_TAB, initCourseTabSaga),
    takeEvery(GROUP_PAGE_ADD_GROUP_COURSE, addGroupCourseSaga),
    takeEvery(GROUP_PAGE_FETCH_COURSE_DETAIL, fetchGroupCourseDetailSaga),
    takeEvery(GROUP_PAGE_DELETE_GROUP_COURSE, deleteGroupCourseSaga)
];
